<template>
<div>
  <GanttElastic 
    ref="timeline" 
    v-if="items.length > 0"
    :tasks="items" 
    :options="options" 
    :dynamic-style="dynamicStyle"
    @chart-task-click="taskClick">
  </GanttElastic>
</div>
</template>

<script>
import GanttElastic from 'gantt-elastic'
import moment from 'moment'

export default {
  components: {
    GanttElastic,
  },
  data() {
    return {
      //カレンダー設定
      /*
      tasks: [
        {
          id: 1,
          label: 'デザイン',
          user: null,
          startTime: this.getMilliseconds('2021-01-22'),
          endTime: this.getMilliseconds('2021-02-06'),
          //duration: 15 * 24 * 60 * 60 * 1000,
          progress: 85,
          type: 'task'
          //collapsed: true,
        },
        {
          id: 2,
          label: 'With great power comes great responsibility',
          user: '<a href="https://www.google.com/search?q=Peter+Parker" target="_blank" style="color:#0077c0;">Peter Parker</a>',
          parentId: 1,
          startTime: this.getMilliseconds('2021-01-23'),
          endTime: this.getMilliseconds('2021-01-27'),
          //duration: 4 * 24 * 60 * 60 * 1000,
          progress: 50,
          type: 'task',
          collapsed: true,
          style: {
            base: {
              fill: '#999',
              stroke: '#333'
            },
          }
        },
        {
          id: 3,
          label: 'Courage is being scared to death, but saddling up anyway.',
          user: '<a href="https://www.google.com/search?q=John+Wayne" target="_blank" style="color:#0077c0;">John Wayne</a>',
          parentId: 2,
          start: this.getMilliseconds('2021-01-24'),
          duration: 2 * 24 * 60 * 60 * 1000,
          progress: 100,
          type: 'task'
        },
        {
          id: 4,
          label: 'Put that toy AWAY!',
          user: '<a href="https://www.google.com/search?q=Clark+Kent" target="_blank" style="color:#0077c0;">Clark Kent</a>',
          start: this.getMilliseconds('2021-01-25'),
          duration: 2 * 24 * 60 * 60 * 1000,
          progress: 50,
          type: 'task',
          dependentOn: [3]
        }
      ],
      */
      options: {
        maxRows: 50,
        maxHeight: 500,
        title: {
          label: 'てすと',
          html: false
        },
        scope: {
          before: 3,
          after: 3,
        },
        times: {
          timeZoom: 20,
        },
        row: {
          height: 20
        },
        calendar: {
          workingDays: [1, 2, 3, 4, 5],
          month: {
            format: {
              long(date) { return date.format('YYYY年 MMMM') },
              medium(date) { return date.format('YY MM') },
              short(date) { return date.format('M') }
            }
          },
          day: {
            height: 25,
            format: {
              long(date) { return date.format('D dddd') },
              medium(date) { return date.format('D ddd') },
              short(date) { return date.format('D') }
            }
          },
          hour: {
            display: false
          },
        },
        chart: {
          progress: {
            bar: false
          },
          expander: {
            display: true
          }
        },
        taskList: {
          expander: {
            straight: false
          },
          columns: [
            {
              id: 1,
              label: '項目',
              value: 'label',
              width: 150,
              expander: true,
            },
            {
              id: 2,
              label: '担当',
              value: task => task.user.length > 0 ? task.user : '',
              width: 100,
              //html: true,
            },
            {
              id: 3,
              label: '進捗',
              value: task => task.progress.toFixed(0) + '%',
              width: 50,
              style: {
                'task-list-header-label': {
                  'text-align': 'center',
                  width: '100%'
                },
                'task-list-item-value-container': {
                  'text-align': 'right',
                  width: '100%'
                }
              },
            },
            {
              id: 4,
              label: '備考',
              value: 'remarks',
              width: 150,
            }
          ]
        },
        locale: {
          name: 'ja',
          weekdays: ['日', '月', '火', '水', '木', '金', '土'],
          months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          Now: 'Now',
          'X-Scale': 'Zoom-X',
          'Y-Scale': 'Zoom-Y',
          'Task list width': 'Task list',
          'Before/After': 'Expand',
          'Display task list': 'Task list'
        }
      },
      dynamicStyle: {
        /*
        'task-list-header-label': {
          'font-weight': 'bold'
        }
        */
      },
      destroy: false,
    }
  },
  props: {
    tasks: {
      type: Array,
      default: () => ([])
    }
  },
  watch: {
    
  },
  computed: {
    items() {
      const map = []
      for (const item of this.tasks) {
        map.push({
          id: item.id,
          label: item.name,
          user: item.chargeText || [],
          parentId: item.parentID || null,
          dependentOn: item.dependentOn || [],
          startTime: this.getMilliseconds(item.start),
          endTime: this.getMilliseconds(moment(item.end).add(1, 'day').format('YYYY-MM-DD')),
          progress: item.progress || 0,
          type: item.type || 'task',
          remarks: item.remarks || null,
          style: {
            base: {
              fill: item.color || '#e74c3c',
              stroke: item.color || '#e74c3c',
            },
          }
        })
      }
      return map
    }
  },
  mounted() {
    
  },
  methods: {
    getMilliseconds(date) {
      return moment(date).valueOf()
    },
    taskClick(event) {
      const item = this.tasks.find(e => e.id === event.data.id)
      this.$emit('taskClick', item)
    },
  }
}
</script>

<style lang='scss' scoped>

</style>